/**
 * Color Utility Functions
 * Tailwind CSS class helpers for consistent color coding across the UI
 */

/**
 * Returns a Tailwind text color class based on ROI value.
 * Uses a gradient from success (>10%) through warning to danger (<-10%).
 */
export function getRoiColor(roi: number): string {
  if (roi > 10) return 'text-theme-success';
  if (roi > 0) return 'text-green-300';
  if (roi > -5) return 'text-theme-warning';
  if (roi > -10) return 'text-orange-400';
  return 'text-theme-danger';
}

/**
 * Returns a Tailwind text color class based on streak value.
 * Positive = success, negative = danger, zero = tertiary.
 */
export function getStreakColor(streak: number): string {
  if (streak > 0) return 'text-theme-success';
  if (streak < 0) return 'text-theme-danger';
  return 'text-theme-text-tertiary';
}

/**
 * Returns Tailwind text and background color classes based on bet outcome.
 */
export function getOutcomeColor(outcome: string): string {
  if (outcome === 'won') return 'text-theme-success bg-theme-success/10';
  if (outcome === 'lost') return 'text-theme-danger bg-theme-danger/10';
  if (outcome === 'push') return 'text-theme-text-secondary bg-theme-surface-hover/10';
  return 'text-theme-text-secondary bg-theme-surface-hover/10';
}
